import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';

const stripeSubscribeSessionSlice = createSlice({
  name: 'stripeSubscribeSession',
  initialState: initialState.stripeSubscribeSession,
  reducers: {
    postStripeSubscriptionCheckoutSessionUrlRequest(
      state,
      _action: PayloadAction<{
        advisorId: string;
        priceId?: string;
        planType?: 'trial' | 'monthly' | 'annual';
        returnPath?: string;
        uiMode?: 'embedded' | 'hosted';
      }>,
    ) {
      state.isLoading = true;
      state.error = false;
      state.success = false;
      state.clientSecret = null;
      state.url = null;
    },
    postStripeSubscriptionCheckoutSessionUrlResponse(
      state,
      action: PayloadAction<{ clientSecret?: string | null; url?: string | null }>,
    ) {
      state.isLoading = false;
      state.success = true;
      state.clientSecret = action.payload.clientSecret ?? null;
      state.url = action.payload.url ?? null;
    },
    postStripeSubscriptionCheckoutSessionUrlFailure(
      state,
      _action: PayloadAction<any>,
    ) {
      state.isLoading = false;
      state.error = true;
    },
    resetStripeSubscribeSession(state) {
      state.isLoading = false;
      state.error = false;
      state.success = false;
      state.clientSecret = null;
      state.url = null;
    },
  },
});

export const {
  postStripeSubscriptionCheckoutSessionUrlRequest,
  postStripeSubscriptionCheckoutSessionUrlResponse,
  postStripeSubscriptionCheckoutSessionUrlFailure,
  resetStripeSubscribeSession,
} = stripeSubscribeSessionSlice.actions;

export const stripeSubscribeSessionReducer =
  stripeSubscribeSessionSlice.reducer;
